export function generate(count, generatorFn) {
    let result = [];
    for (let i = 1; i <= count; i++) {
        result.push(generatorFn(i));
    }
    return result;
}
export function getRandomElement(array) {
    return array[Math.floor(Math.random() * array.length)];
}
const companyNames = [
    'ACME Inc.',
    'Onlinegroup',
    'Wooden Floors Ltd.',
    'Fair Weather',
    'Gogol',
    'Money Investments',
    'Insurance Comp.',
    'Comfy Chairs',
    'TastyFood',
    'Shortcut Electrics',
    'Prime',
    'GoodEar',
    'Bills Bakery',
    'Paul the Plumber',
    'Bonnys Bagels'
];
const firstNames = [
    'Abraham',
    'Berta',
    'Cäsar',
    'Dorothea',
    'Francesco',
    'Gustav',
    'Heinrich',
    'Ida',
    'Joseph',
    'Konrad',
    'Leonard',
];
const lastNames = [
    'Müller',
    'Neumann',
    'Oppenheimer-Friedensberger',
    'Österreicher',
    'Pilz',
    'Queen',
    'Richards',
    'Siegfried',
    'Theodor',
    'Ûllrich',
    'Vogel',
    'Werger',
    "Xaver",
    "Zeppelin",
];
export function getRandomCompany() {
    return getRandomElement(companyNames);
}
export function getRandomFirstName() {
    return getRandomElement(firstNames);
}
export function getRandomLastName() {
    return getRandomElement(lastNames);
}
export function getRandomTitle() {
    return 'Dr.'; // everyone`s a doctor
}
export function getRandomName() {
    return getRandomFirstName() + ' ' + getRandomLastName();
}
//# sourceMappingURL=mock.js.map